import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import './pagination.component.scss';

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  hasNext: boolean;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
}

const PaginationComponent: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  hasNext,
  onPageChange,
  isLoading = false
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Always show pagination numbers
  return (
    <Box className="pagination-container" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        แสดง {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} จาก {totalItems} รายการ
      </Typography>
      
      <Stack spacing={2} alignItems="center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          shape="rounded"
          showFirstButton
          showLastButton
          size="large"
          sx={{
            '& .MuiPaginationItem-root': {
              fontSize: '0.875rem',
            },
            '& .MuiPaginationItem-page.Mui-selected': {
              backgroundColor: '#007bff',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#0056b3',
              },
            },
          }}
        />
      </Stack>
    </Box>
  );


};

export default PaginationComponent; 